import * as React from 'react';

import './AddressLoading.scss';

function AddressLoading() {
  return (
    <div className="rp-address-loading">
      <div className="rp-address-loading--data">
        <span className="loading-bar short" />
        <span className="loading-bar large" />
        <span className="loading-bar large" />
        <span className="loading-bar buttons" />
      </div>
    </div>
  );
}

export default AddressLoading;
